import React from "react";
import { AlertTriangle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import { Button } from "../ui/button";

const ConfirmDialog = ({
  open,
  onOpenChange,
  title = "تأكيد الإجراء",
  description = "هل تريد المتابعة؟",
  confirmLabel = "تأكيد",
  cancelLabel = "إلغاء",
  onConfirm,
  tone = "danger",
  loading = false,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent dir="rtl" className="sm:max-w-md">
      <DialogHeader>
        <div
          className="mb-3 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-warning-50 text-warning-700 ring-1 ring-inset ring-warning-200 dark:bg-warning-950/40 dark:text-warning-300 dark:ring-warning-900/50"
          aria-hidden="true"
        >
          <AlertTriangle size={22} />
        </div>
        <DialogTitle className="text-start">{title}</DialogTitle>
      </DialogHeader>
      <p className="text-sm leading-6 text-neutral-600 dark:text-neutral-300">
        {description}
      </p>
      <DialogFooter className="gap-2 sm:justify-start">
        <Button
          type="button"
          variant="outline"
          onClick={() => onOpenChange?.(false)}
          disabled={loading}
        >
          {cancelLabel}
        </Button>
        <Button
          type="button"
          variant={tone === "danger" ? "destructive" : "default"}
          onClick={onConfirm}
          disabled={loading}
          aria-busy={loading}
        >
          {loading ? "جارٍ التنفيذ..." : confirmLabel}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ConfirmDialog;
